import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import ShowLoginForm from '~/auth/components/ShowLoginForm'
import { Footer, Link } from '~/components'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ROUTES from '~/shared/constants/routes.const'
import { AppLanguage } from '~/types/locale'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function LoginPage(): React.ReactElement {
  const { t } = useTranslation('start')

  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isTablet = useCheckBreakpoint({ lt: Breakpoint.LG })
  const imageHeight = isMobile ? 31 : isTablet ? 45 : 68
  const imageWidth = isMobile ? 160 : isTablet ? 232 : 355
  const router = useRouter()
  const isNoLang = router.locale === AppLanguage.NO

  const bgSrcKey = isTablet
    ? isNoLang
      ? 'landing/start/bgm_no_v2.jpg'
      : 'landing/start/bgm_en_v2.jpg'
    : isNoLang
    ? 'landing/start/bg-image_no_v2.jpg'
    : 'landing/start/bg-image_en_v2.jpg'
  const bgHeight = isTablet ? 548 : 800
  const bgWidth = isTablet ? 360 : 1936
  const bgMediaQuery = [
    {
      screen: '(max-width: 1023px)',
      width: '360px',
      srcKey: isNoLang ? 'landing/start/bgm_no_v2.jpg' : 'landing/start/bgm_en_v2.jpg',
    },
    {
      screen: '(min-width: 1024px)',
      width: '1280px',
      srcKey: isNoLang ? 'landing/start/bg-image_no_v2.jpg' : 'landing/start/bg-image_en_v2.jpg',
    },
  ]

  return (
    <>
      <div className="relative bg-gradient-sign-up lg:min-h-screen">
        <ResponsiveImage
          alt={t('intro.heading')}
          fetchPriority="high"
          height={bgHeight}
          imageClassName="fixed lg:h-screen w-full lg:object-cover"
          imageWidths="[360, 1936]"
          loading="eager"
          mediaQuery={bgMediaQuery}
          srcKey={bgSrcKey}
          width={bgWidth}
        />
        <div className="flex flex-col items-center lg:py-4 xl:pt-0 w-full min-h-screen overflow-x-hidden justify-center bg-black/70 backdrop-blur-0">
          <Link to={ROUTES.HOME}>
            <ResponsiveImage
              height={imageHeight}
              imageClassName="flex flex-col items-center justify-center mb-8 lg:mt-5"
              loading="eager"
              srcKey="logos/house-of-math-logo-white.png"
              width={imageWidth}
            />
          </Link>
          <div className="bg-white rounded text-black px-4 py-6 md:px-15 md:py-10 m-4 max-w-screen-19/20">
            <ShowLoginForm />
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
